import { money, tag } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const GetPayOverTimeLoanDetails = gql`
  fragment TransactionRowComponentFragment on TransactionRowComponent {
    __typename
    id
    primaryDetail {
      copy
    }
    primaryText {
      copy
    }
    secondaryDetail {
      copy
    }
    secondaryText {
      copy
    }
    tags {
      ...tag
    }
    onClick {
      __typename
      ... on TransactionDetailsNavigationAction {
        id
        analyticsEvent {
          name
          properties {
            key
            value
          }
        }
        transaction {
          ... on LendingTransaction {
            id
            type
            description
            status
            direction
            value {
              ...money
            }
            createdAt
          }
        }
      }
    }
  }

  query PayOverTimeLoanDetails($loanId: ID!) {
    payOverTimeLoanDetails(loanId: $loanId) {
      __typename
      ... on PayOverTimeLoanDetailsError {
        code
        message
        title
      }
      ... on PayOverTimeLoanDetailsSuccess {
        loanName
        autoPayDate
        banner {
          message
          title
          bannerStatus
        }
        amountDue {
          ...money
        }
        dueDate
        id
        isAutoPayEnabled
        showNeverMissPaymentSheet
        paymentSchedule {
          installments {
            dueDateFormatted
            installmentState
            amountDue {
              ...money
            }
          }
          paidBalance {
            ...money
          }
          remainingBalance {
            ...money
          }
        }
        remainingBalance {
          ...money
        }
        transactions {
          __typename
          children {
            ...TransactionRowComponentFragment
          }
          id
          title {
            copy
          }
        }
      }
    }
  }

  ${money}
  ${tag}
`;

export default GetPayOverTimeLoanDetails;
